import '../../styles/InfoMarker.css'
import { useState,useEffect,useMemo } from 'react';
import Action from '../../Action'
import Modal from 'react-modal';
import InputForm from '../../InputForm';
import LoadAdding from '../../LoadAdding';
import PingModal from '../../PingModal';
import ActionModal from '../../ActionModal';
import HostSelector from '../../HostSelector'
import AlertsByHost from '../../AlertsByHost'
import HealthByHost from '../../HealthByHost';
import CarrilesArco from '../../CarrilesArco';
import { useFetch } from '../../../hooks/useFetch';
import LoadSimple from '../../LoadSimple';
import ConsolaHost from '../../ConsolaHost';
import {servidores_id,permisos_codigo_id} from '../../generales/GroupsId';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const pingModalStyles = {
  overlay: {
    zIndex: 3000,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    backdropFilter: 'blur(4px)'
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '450px',
    maxWidth: '90vw',
    padding: '0',
    border: 'none',
    borderRadius: '16px',
    background: '#fff',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    overflow: 'hidden'
  },
};

const consoleModalStyles = {
  overlay: {
    zIndex: 3500,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    backdropFilter: 'blur(8px)'
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '1000px',
    height: '650px',
    maxWidth: '95vw',
    maxHeight: '90vh',
    padding: '0',
    border: 'none',
    borderRadius: '12px',
    background: '#1e1e1e',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
    overflow: 'hidden'
  },
};
const InfoMarker = ({isOpen,dataCriticalities,suveryId,setSuveryId,setImportModalOpen,languaje,dataAgencies,mode,downs_list,userPermissions,source,handleShowPopup,devices,mapAux,setmapAux, data,closeInfoMarker,server,ubiActual,search_problems }) => {
  // console.log(downs_list)

  // ── helpers (no hooks) ───────────────────────────────────────────────────
  const normalizeCoord = (value) => {
    if (value === null || value === undefined) return null;
    return Number(parseFloat(value).toFixed(5));
  };
  const filterByCoordsWithStatus = (list, lat, lon, status) => {
    const nLat = normalizeCoord(lat);
    const nLon = normalizeCoord(lon);
    return list
      .filter(obj => normalizeCoord(obj.latitude) === nLat && normalizeCoord(obj.longitude) === nLon)
      .map(obj => ({ ...obj, status }));
  };

  // ── all hooks unconditionally ────────────────────────────────────────────
  const [consoleActive, setConsoleActive] = useState(false)
  const [pingModalOpen, setPingModalOpen] = useState(false);
  const [statusPing, setStatusPing] = useState(false);
  const [infoHostC, setInfoHostC] = useState({ ip: 0 })
  const [infoHostP, setInfoHostP] = useState([])
  const [hostId, setHostId] = useState(data?.hostidC)
  const [hostIdP, setHostIdP] = useState(0)
  const [listSelected, setListSelected] = useState((source == 'Monitoreo') ? 1 : 2)
  const [hostSelected, setHostSelected] = useState(2)
  const [actionSelected, setActionSelected] = useState({})
  const [listActions, setListActions] = useState({ data: [], loading: true, error: null });

  const hadleChangeList = (e) => { setListSelected(e) }
  const handleChangeOption = (e) => { setHostSelected(e); setListSelected(1) }
  const actionConsole = () => { setConsoleActive(!consoleActive) }

  function openPingModal() { setPingModalOpen(true); }
  function closePingModal() { setPingModalOpen(false); }

  const handlePingClick = (d) => {
    setActionSelected(d)
    setStatusPing(true)
    openPingModal()
  };

  useEffect(() => {
    if (data?.hostidC) {
      setHostId(data.hostidC);
    }
  }, [data?.hostidC]);

  function search_actions() {
    if (!infoHostC?.ip || infoHostC.ip === 0) return;
    setListActions({ data: [], loading: true, error: listActions.error })
    const fetchData = async () => {
      try {
        const response = await fetch(server.url + '/api/v1/zabbix/hosts/actions/' + infoHostC.ip, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });
        if (response.ok) {
          const response_data = await response.json();
          setListActions({ data: response_data.data, loading: false, error: listActions.error })
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        setListActions({ data: listActions.data, loading: false, error: error })
      }
    };
    fetchData();
  }

  useEffect(() => {
    search_actions()
  }, [infoHostC?.ip])

  useEffect(() => {
    localStorage.removeItem('data_info_marker')
  }, [])

  const downsData = (downs_list.data && downs_list.data.downs) ? downs_list.data.downs : [];
  const hostsData = (devices.data && devices.data.hosts) ? devices.data.hosts : [];
  const unknownData = (devices.data && devices.data.host_unknown) ? devices.data.host_unknown : [];

  const mix = useMemo(() => {
    if (!isOpen || !data || !data.end_lat) return [];
    if (source === 'Monitoreo') {
      if (ubiActual.dispId !== -1) {
        let items = [
          ...filterByCoordsWithStatus(downsData, data.end_lat, data.end_lon, 0),
          ...filterByCoordsWithStatus(hostsData, data.end_lat, data.end_lon, 1),
          ...filterByCoordsWithStatus(unknownData, data.end_lat, data.end_lon, 2),
        ];
        if (items.length === 0) {
          return [{ hostid: data.hostidC, Host: data.name_hostC, latitude: data.end_lat, longitude: data.end_lon, ip: data.name_hostipC, status: 3 }];
        }
        return items;
      } else {
        return downsData.filter(obj =>
          (((obj.latitude.charAt(obj.latitude.length - 1) == 0) ? obj.latitude.slice(0, -1) : obj.latitude) === ((data.end_lat.charAt(data.end_lat.length - 1) == 0) ? data.end_lat.slice(0, -1) : data.end_lat)) &&
          (((obj.longitude.charAt(obj.longitude.length - 1) == 0) ? obj.longitude.slice(0, -1) : obj.longitude) === ((data.end_lon.charAt(data.end_lon.length - 1) == 0) ? data.end_lon.slice(0, -1) : data.end_lon))
        );
      }
    } else {
      return [{ hostid: data.hostidC, Host: data.name_hostC, latitude: data.end_lat, longitude: data.end_lon, ip: data.name_hostipC }];
    }
  }, [isOpen, data, source, ubiActual.dispId, downsData, hostsData, unknownData]);

  useEffect(() => {
    const found = mix.find(obj => obj.hostid === hostId);
    setInfoHostC(found || mix[0] || { ip: 0 });
  }, [hostId, mix])

  useEffect(() => {
    const relation = (ubiActual.dispId !== -1 && devices.data && devices.data.relations)
      ? devices.data.relations.find(obj => obj.hostidC === data?.hostidC)
      : undefined;
    if (relation !== undefined) {
      setHostIdP(relation.hostidP);
    }
  }, [data?.hostidC, ubiActual.dispId, devices.data])

  useEffect(() => {
    if (ubiActual.dispId !== -1 && devices.data && devices.data.hosts) {
      const hostidPa = devices.data.hosts.find(obj => obj.hostid === hostIdP)
      setInfoHostP(hostidPa)
    }
  }, [hostIdP, ubiActual.dispId, devices.data])

  useEffect(() => {
    const timer = setTimeout(() => { setStatusPing(false) }, 5000);
    return () => clearTimeout(timer);
  }, [statusPing]);

  // ── early return AFTER all hooks ─────────────────────────────────────────
  if (!isOpen) return null;

  return (
    <>
      <div className="info-modal-overlay" onClick={closeInfoMarker}>
        <div className="info-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="info-modal-hdr">
            <h2>Información general de dispositivo</h2>
            <div className="info-modal-close" onClick={closeInfoMarker}>
              <svg width="12" height="12" viewBox="0 0 14 14">
                <line x1="2" y1="2" x2="12" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
                <line x1="12" y1="2" x2="2" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              </svg>
            </div>
          </div>

          <div className="info-device-bar">
            <div>Host ({mix.length})</div>
            <div>IP</div>
            <div>ID</div>
            <div>Nivel</div>
            <div>Status</div>
          </div>

          <div className="info-device-row">
            <div className="info-device-sel-container">
              <select className="info-device-sel" value={hostId} onChange={(e) => setHostId(Number(e.target.value))}>
                {mix.map((h, i) => (
                  <option key={i} value={h.hostid}>{h.Host}</option>
                ))}
              </select>
            </div>
            <div style={{ textAlign: 'center' }}>{infoHostC?.ip || '---'}</div>
            <div style={{ textAlign: 'center' }}>{infoHostC?.hostid || '---'}</div>
            <div style={{ textAlign: 'center' }}>{infoHostC?.level || 1}</div>
            <div style={{ textAlign: 'center' }}>
              <span className={`status-badge ${(infoHostC?.status === 1 || source !== 'Monitoreo') ? 'up' : 'down'}`}>
                {(infoHostC?.status === 1 || source !== 'Monitoreo') ? 'Up' : 'Down'}
              </span>
            </div>
          </div>

          <div className="info-modal-msg">
            {infoHostP && infoHostP.Host ? `Dependencia: ${infoHostP.Host} (${infoHostP.ip})` : 'Sin relación con algún aps'}
          </div>

          <div className="info-selection-summary">
            Dispositivo seleccionado (ID): <strong>{infoHostC?.hostid || '---'}</strong>
          </div>

          <div className="info-tabs-nav">
            <div className={`info-tab-item ${listSelected === 1 ? 'active' : ''}`} onClick={() => setListSelected(1)}>Acciones</div>
            <div className={`info-tab-item ${listSelected === 2 ? 'active' : ''}`} onClick={() => setListSelected(2)}>Alarmas</div>
            <div className={`info-tab-item ${listSelected === 3 ? 'active' : ''}`} onClick={() => setListSelected(3)}>Salud</div>
            {ubiActual.dispId === 9 && (
              <div className={`info-tab-item ${listSelected === 9 ? 'active' : ''}`} onClick={() => setListSelected(9)}>Carriles</div>
            )}
          </div>

          <div style={{ minHeight: '200px', maxHeight: '450px', overflowY: 'auto', background: '#fff' }}>
            {listSelected === 1 ? (
              <div className="info-actions-grid">
                {userPermissions.some(objeto => objeto.permission_id === permisos_codigo_id['acciones_host']) ? (
                  listActions.loading ? <div style={{ gridColumn: 'span 3', padding: '40px' }}><LoadSimple /></div> :
                    (!listActions.data?.actions || listActions.data.actions.length === 0) ? <div style={{ gridColumn: 'span 3' }} className="empty-tab">Sin resultados</div> :
                      listActions.data.actions.map((elemento, indice) => (
                        <button
                          key={indice}
                          className="btn-action-blue"
                          onClick={() => elemento.action_id == 21 ? actionConsole() : handlePingClick(elemento)}
                        >
                          {elemento.name}
                        </button>
                      ))
                ) : <div style={{ gridColumn: 'span 3' }} className="empty-tab">Sin permisos</div>}
              </div>
            ) : listSelected === 2 ? (
              <AlertsByHost dataCriticalities={dataCriticalities} handleShowPopup={handleShowPopup} languaje={languaje} suveryId={suveryId} setSuveryId={setSuveryId} setImportModalOpen={setImportModalOpen} dataAgencies={dataAgencies} mode={mode} userPermissions={userPermissions} ubiActual={ubiActual} mapAux={mapAux} setmapAux={setmapAux} search_problems={search_problems} hostId={hostId} server={server}></AlertsByHost>
            ) : listSelected === 3 ? (
              <HealthByHost languaje={languaje} mode={mode} hostId={hostId} server={server}></HealthByHost>
            ) : listSelected === 9 ? (
              <CarrilesArco languaje={languaje} mode={mode} hostId={hostId} server={server}></CarrilesArco>
            ) : null}
          </div>
        </div>
      </div>

      <Modal
        isOpen={pingModalOpen}
        onRequestClose={closePingModal}
        style={pingModalStyles}
        contentLabel="Action Modal"
      >
        <ActionModal mode={mode} handleShowPopup={handleShowPopup} ip={infoHostC?.ip} actionSelected={actionSelected} server={server} isOpen={pingModalOpen} data={data} statusPing={statusPing} closeActionModal={closePingModal}></ActionModal>
      </Modal>

      <Modal
        isOpen={consoleActive}
        onRequestClose={actionConsole}
        style={consoleModalStyles}
        contentLabel="SSH Terminal"
      >
        <ConsolaHost server={server} ip={infoHostC?.ip} actionConsole={actionConsole} hostId={hostId} />
      </Modal>
    </>
  );
};

export default InfoMarker